<template>
    <section class="organization-details mt-2">
        <div class="row mt-2 mb-2">
            <div class="col-md-12">
                <h3>
                    {{ organization.title }}
                </h3>
            </div>
        </div>
        <hr>
        <div class="row mt-2">
            <div class="col-md-12">
                <entry-listing
                    :form_requirements="form_requirements"
                    title="Organization Overview"
                    :read_only="false"
                    resource="organization"
                    :show_title="false"
                ></entry-listing>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: ['organization', 'form_requirements'],
        methods: {
            updateLoaded(loaded) {
                this.$emit('updateLoaded', loaded);
            }
        },
        watch: {
            organization() {
                this.updateLoaded(true);
            }
        }
    }
</script>
